import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { BotPhaseListStore } from "../../store/BotPhaseListStore";

type BotPhaseListDialogsProps = {
  store: BotPhaseListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de BotPhase.
 * Separado para mantener BotPhaseListPage más limpio.
 */
export const BotPhaseListDialogs: React.FC<BotPhaseListDialogsProps> = observer(
  ({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  }
);
